var DeleteCompanyContactModalController = /** @class */ (function () {
    function DeleteCompanyContactModalController(userService) {
        this.userService = userService;
    }
    DeleteCompanyContactModalController.prototype.$onInit = function () {
        this.userDetails = this.resolve.userDetails;
        this.userDetails.name = this.userDetails.firstName + this.userDetails.lastName;
        this.deleteContactUserInfo = this.resolve.deleteContactUserInfo;
        this.selectedExistingContact = null;
        this.isSaveClicked = false;
        this._setDeleteContactInfo();
        this.callbackObject = { callbackType: 'cancel', entity: { primaryContact: null } };
    };
    DeleteCompanyContactModalController.prototype._setDeleteContactInfo = function () {
        if (this.deleteContactUserInfo.contactsList) {
            this.deleteContactUserInfo.contactsList.map(function (contact) {
                if (!contact.name || contact.name == '') {
                    contact.name = contact.firstName + " " + contact.lastName;
                }
            });
        }
    };
    DeleteCompanyContactModalController.prototype.removeContact = function () {
        this.isSaveClicked = true;
        if (this.deleteContactUserInfo.contactsList.length == 0) {
            this.closeModal();
        }
        else {
            if (this.selectedExistingContact) {
                this.closeModal();
            }
        }
    };
    DeleteCompanyContactModalController.prototype.existingUserChanged = function () {
        this.isSaveClicked = false;
        this.callbackObject.entity.primaryContact = this.selectedExistingContact ? this.selectedExistingContact : null;
    };
    DeleteCompanyContactModalController.prototype.closeModal = function () {
        this.modalInstance.close(this.callbackObject);
    };
    DeleteCompanyContactModalController.prototype.dismissModal = function () {
        this.modalInstance.dismiss('cancel');
    };
    return DeleteCompanyContactModalController;
}());
DeleteCompanyContactModalController.$inject = ['userService'];
import * as TEMPLATE from 'raw-loader!./delete-company-contact-modal.html';
export var DeleteCompanyContactModalComponent = {
    selector: 'deleteCompanyContactModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: DeleteCompanyContactModalController,
        template: TEMPLATE.default
    }
};
//# sourceMappingURL=delete-company-contact-modal.js.map